/**
 * src/components/header/NavToggle.js
 *
 * Botón hamburguesa para móvil. Alterna la clase open en el header.
 * Props: { isOpen: Signal<boolean>, onToggle: Function }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { effect } from '@core/signal.js'

define('NavToggle', ({ isOpen, onToggle }) => {
    const btn = h('button', {
        className: 'nav-toggle',
        type: 'button',
        'aria-label': 'Abrir menú'
    })

    const bar = () => h('span', { className: 'nav-toggle__bar' })
    btn.appendChild(bar())
    btn.appendChild(bar())
    btn.appendChild(bar())

    btn.addEventListener('click', onToggle)

    if (isOpen) {
        effect(() => {
            btn.classList.toggle('nav-toggle--open', isOpen.get())
            btn.setAttribute('aria-expanded', String(isOpen.get()))
        })
    }

    return btn
})
